/**
 * Check JS Date validity
 */

/**  Environment  */
import environmentVariables from '../util/environmentVariables';
environmentVariables();

export default function validDate(input: string | Date | number): boolean {
    try {
        const date = new Date(input);
        if (!date || !date.getTime || isNaN(date.getTime())) {
            return false;
        }
    } catch (error) {
        return false;
    }

    return true;
}
